import React, { useState } from "react";
import "./PGAModelBuilderCalcTab.css";
import { graphql, useLazyLoadQuery, useMutation } from "react-relay";
import Select from "react-select";
import SelectField from "../../../../../../SelectField";
import PGAModelBuilderInput from "../../PGAModelBuilderInput";
import PGAModelBuilderCalcTabCalculationSelect from "./PGAModelBuilderCalcTabCalculationSelect";
import PGAModelBuilderFeatureOutput from "./PGAModelBuilderFeatureOutput";
import FlexBreak from "../../../../../../FlexBreak";

const GET_CALC_OPTIONS = graphql`
  query PGAModelBuilderCalcTabGetCalcOptionsQuery {
    pgaModelCalcClassifications {
      id
      name
    }
  }
`;

const UPDATE_FEATURE = graphql`
  mutation PGAModelBuilderCalcTabUpdateFeatureMutation(
    $input: PGATourModelUpdateFeatureInput!
  ) {
    pgaTourModelUpdateFeature(input: $input) {
      success
    }
  }
`;

const DELETE_FEATURE = graphql`
  mutation PGAModelBuilderCalcTabDeleteFeatureMutation(
    $input: PGATourModelDeleteFeatureInput!
  ) {
    pgaTourModelDeleteFeature(input: $input) {
      success
    }
  }
`;

export default function PGAModelBuilderCalcTab(props) {
  const [updateFeatureMutation] = useMutation(UPDATE_FEATURE);
  const [deleteFeatureMutation] = useMutation(DELETE_FEATURE);

  const [selectedClassification, setSelectedClassification] = useState(
    props.feature.calculation && props.feature.calculation.classification
      ? {
          value: props.feature.calculation.classification.id,
          label: props.feature.calculation.classification.name,
        }
      : undefined
  );
  const [selectedCalculation, setSelectedCalculation] = useState(
    props.feature.calculation
      ? {
          value: props.feature.calculation.id,
          label: props.feature.calculation.name,
        }
      : undefined
  );
  const [selectedWeight, setSelectedWeight] = useState(props.feature.weight);

  const data = useLazyLoadQuery(GET_CALC_OPTIONS, {
    classificationID: selectedClassification
      ? selectedClassification.value
      : undefined,
  });

  function updateCalcFeature() {
    const calcID = selectedCalculation ? selectedCalculation.value : null;

    updateFeatureMutation({
      variables: {
        input: {
          featureId: props.feature.id,
          calculationId: calcID,
          weight: Number.parseInt(selectedWeight),
        },
      },
    });
  }

  function deleteCalcFeature() {
    deleteFeatureMutation({
      variables: {
        input: {
          featureId: props.feature.id,
        },
      },
      onCompleted: () => props.setCalcReloads(props.calcReloads + 1),
    });
  }

  React.useEffect(() => {
    updateCalcFeature();
  }, [selectedWeight, selectedCalculation]);

  return (
    <div className="pga-model-builder-tab">
      <button className="see-more-button" onClick={deleteCalcFeature}>
        Delete Feature
      </button>
      <FlexBreak />
      <div style={{ width: "100%", flex: "2 2 0", zIndex: "3" }}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>
          Classification
          <Select
            options={data.pgaModelCalcClassifications.map((classification) => {
              return {
                value: classification.id,
                label: classification.name,
              };
            })}
            value={selectedClassification}
            onChange={(selected) => {
              setSelectedClassification(selected);
              setSelectedCalculation(undefined);
            }}
          />
        </label>
      </div>

      <div style={{ width: "100%", flex: "2 2 0", zIndex: "3" }}>
        <React.Suspense
          fallback={
            /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
            <label>
              Calculation
              <Select options={[]} />
            </label>
          }
        >
          <PGAModelBuilderCalcTabCalculationSelect
            selectedClassification={selectedClassification}
            selectedCalculation={selectedCalculation}
            setSelectedCalculation={setSelectedCalculation}
          />
        </React.Suspense>
      </div>

      <div style={{ width: "100%", flex: "1 1 0" }}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>
          Weight (%)
          <PGAModelBuilderInput
            type="number"
            value={selectedWeight}
            onChange={(e) => {
              let newVal = e.target.value;

              if (newVal < 0) {
                newVal = 0;
              }

              if (newVal > 100) {
                newVal = 100;
              }

              setSelectedWeight(newVal);
            }}
          />
        </label>
      </div>
      <FlexBreak />
      <React.Suspense fallback={<div>Loading feature output...</div>}>
        <PGAModelBuilderFeatureOutput
          featureID={props.feature.id}
          featureOutputReloads={props.featureOutputReloads}
        />
      </React.Suspense>
    </div>
  );
}
